import React from "react";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { NavLink } from "react-router-dom";

function WidgetItem(props) {
  let langCode = "en";
  if (props.activeLanguage !== undefined) {
    langCode = props.activeLanguage.code;
  }

  return (
    <div class="col-12  col-sm-12 col-md-3">
    {(props.code == 61) && (
        <a
          href={`${props.url}`}
      
        >
          <div class="card">
            <img
              class="card-img-top"
              src={`assets/img/widgets/${props.logo}`}
              alt={props.name_en}
              height="200"
            />
            <div class="card-block">
              <h5 class="card-title text-center">
                {langCode == "ar" ? props.name_ar : props.name_en}
              </h5>
              {/* <p class="card-text">{props.text_en}</p> */}
            </div>
          </div>
        </a>
      )}
    {(props.code == 8 || props.code==9) && (
        <a
          href="#"
          onClick={event => {
            document.getElementById(props.code).submit();
            event.preventDefault();
          }}
        >
          <div class="card">
            <img
              class="card-img-top"
              src={`assets/img/widgets/${props.logo}`}
              alt={props.name_en}
              height="200"
            />
            <div class="card-block">
              <h5 class="card-title text-center">
                {langCode == "ar" ? props.name_ar : props.name_en}
              </h5>
              {/* <p class="card-text">{props.text_en}</p> */}
            </div>
          </div>
        </a>
      )}
      {props.code == -1 && (
        <NavLink to={`/StudentApp.aspx/${props.code}`}>
          {/* <a
                  href="#"
                  onClick={event => {
                    document.getElementById(item.code).submit();
                    event.preventDefault();
                  }}
                > */}

          <div class="card">
            <img
              class="card-img-top"
              src={`assets/img/widgets/${props.logo}`}
              alt={props.name_en}
              height="200"
            />
            <div class="card-block">
              <h5 class="card-title text-center">
                {langCode == "ar" ? props.name_ar : props.name_en}
              </h5>
              {/* <p class="card-text">{props.text_en}</p> */}
            </div>
          </div>
        </NavLink>
      )}
      {props.code != -1 && props.code != 8 && props.code != 9  && props.code != 61 && (
        <NavLink to={`/StudentApp.aspx/${props.code}`}>

          <div class="card">
            <img
              class="card-img-top"
              src={`assets/img/widgets/${props.logo}`}
              alt={props.name_en}
              height="200"
            />
            <div class="card-block">
              <h5 class="card-title text-center">
                {langCode == "ar" ? props.name_ar : props.name_en}
              </h5>
              {/* <p class="card-text">{props.text_en}</p> */}
            </div>
          </div>
        </NavLink>
      )}
    </div>
  );
}
export default withLocalize(WidgetItem);



// WEBPACK FOOTER //
// ./src/pages/Home/WidgetItem.js